module.exports = __webpack_public_path__ + "static/media/discover-illustration.0009df5b.svg";